import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAuthTokensKey, getNetworkKey, getUpdateSlatesKey, } from '../../utils/keys';
import { authTokenUpdater, navigationSlateReducer, networkUpdater, } from '../cache/useCachedNetwork';
export const useUpdateSlates = (options) => {
    const { useMutationOptions, fields } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const networkKey = getNetworkKey();
    const authTokenKey = getAuthTokensKey();
    const updateSlatesKey = getUpdateSlatesKey();
    return useMutation((input) => client.slates.update(input, fields), {
        onSuccess: data => {
            const updatedSlateIds = data.map(slate => slate.id);
            // queryClient.invalidateQueries(networkKey)
            queryClient.setQueryData(networkKey, networkUpdater(network => ({
                navigationSlates: navigationSlateReducer(network, updatedSlateIds, data),
            })));
            queryClient.setQueryData(authTokenKey, authTokenUpdater({
                network: networkUpdater(network => ({
                    navigationSlates: navigationSlateReducer(network, updatedSlateIds, data),
                })),
            }));
        },
        mutationKey: updateSlatesKey,
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUpdateSlates.js.map